import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../components/comments';

import style from './carddesigns.scss';
import { getNameFromURL, setTitle, trackPage } from '../shared/utils';
import { CardComponent } from "../components/card";

export class CardDesignsPage extends LitElement {

    static get properties() {
        return {            
            thread: Object            
        }
    }

    constructor() {
        super();    
        this.uid = null;
        this.thread = null;
        this.cards = null
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();      
        this.uid = getNameFromURL();                    
        setTitle('Card Designs');
        this.fetchData();
    }

    async fetchData() {                                
        let ret = await fetch(`./api/carddesigns/${this.uid}`);
        let json = await ret.json();     
        this.thread = json.thread || json;                      
        if(json.cards){
            this.cards = json.cards;
        }         
        setTitle(this.thread.name);
        this.update();       
    }

    render() {   
        if(!this.thread)
            return html`Loading...`;           

        let url = `https://discord.com/channels/455784011336384522/938197062439272531`;

        return html`
            <h1>${this.thread.name}${this.thread.closed?' - CLOSED':''}</h1>  
            <p>${this.thread.desc}</p>          
            <p>${this.thread.closed?'This contest is now closed':html`Suggest a card or vote on your favourite designs for this contest. To submit or discuss a card, visit our <a href=${url} target="_blank">Discord</a>!`}
            </p>
            ${this.cards?.map(c=>{
                
                c.cost = c.cost || {};
                c.description = c.text;
                c.artwork = c.artwork || 'creature_icon_bolgar';                

                let cc = new CardComponent()
                cc.id = -1;
                cc.loadedID = -1;
                cc.data = c;
                return html`${cc}`;
            })}
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('carddesigns-page', CardDesignsPage);